import React, { useEffect, useState } from "react";
import { LuChevronDown } from "react-icons/lu";
import { getLegalPolicies } from "../../../../api/profile";
import "./style.css";
export const Policies = () => {
  const [result, setResult] = useState({ data: [], loading: true, error: false });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const response = await getLegalPolicies({});
        if (response?.error && response.message === "No LegalPolicies found for this corporation") {
          if (alive) setResult({ data: [], loading: false, error: false });
          return;
        }
        if (response?.error || !Array.isArray(response?.data)) throw new Error("policies unavailable");
        if (alive) setResult({ data: response.data, loading: false, error: false });
      } catch { if (alive) setResult({ data: [], loading: false, error: true }); }
    };
    load(); return () => { alive = false; };
  }, [attempt]);
  return <main className="profile-container">
    <div className="profile-container-header"><h1>Privacidad</h1><p>Cómo tratamos tus datos y las condiciones de compra.</p></div>
    {result.loading && <p role="status">Cargando políticas…</p>}
    {result.error && <div role="status" className="account-panel"><p>No hemos podido cargar las políticas.</p><button type="button" className="account-secondary" onClick={() => { setResult({ data: [], loading: true, error: false }); setAttempt(value => value + 1); }}>Reintentar</button></div>}
    {!result.loading && !result.error && !result.data.length && <p className="account-panel">Este comercio todavía no ha publicado sus políticas.</p>}
    {!!result.data.length && <div className="account-panel account-policies">{result.data.map(policy => <details key={policy.legalPoliciesId}><summary>{policy.title}<LuChevronDown aria-hidden="true" /></summary><div className="account-policy-text" dangerouslySetInnerHTML={{ __html: policy.text }} /></details>)}</div>}
  </main>;
};
